import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { switchMap, of } from 'rxjs';
import { ColorsQuery } from 'src/app/services/akita/colors.query';
import { AuthService } from 'src/app/services/auth/auth.service';
import { NavBarService } from 'src/app/services/navbar/navbar.service';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrl: './loading.component.scss'
})
export class LoadingComponent implements OnInit, OnDestroy{
  @Input() loading: boolean = true;
  primaryColor: string = '';
  backgroundColor: string = '';
  primaryLightColor: string = '';
  textColor: string = '';

  constructor(private authService: AuthService, private router: Router, private colorsQuery: ColorsQuery, private NavBarService: NavBarService) { }


  ngOnInit(): void {

  }


  ngOnDestroy(): void {

  }
}
